export default "__VITE_ASSET__99612838__"